import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "../../../shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const DYNAMIC_FORMS_SIDENAV_LINK = new InjectionToken<void>("DYNAMIC_FORMS_SUB_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "dynamic-forms",
        icon: "tree-structure",
        label: "SETTINGS.ITEMS.DYNAMIC_FORMS",
        items: [
          {
            id: "dynamic-fields",
            label: "SETTINGS.ITEMS.DYNAMIC_FIELDS",
            routerLink: "/settings/dynamic-fields",
            permissions: COMMON_GUARD_OPTIONS.DYNAMIC_FIELD.VIEW.permissions,
          },
          {
            id: "dynamic-form",
            label: "SETTINGS.ITEMS.DYNAMIC_FORMS",
            routerLink: "/settings/dynamic-forms",
            permissions: COMMON_GUARD_OPTIONS.DYNAMIC_FORM.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
